/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscriptionalertpurchaseunavailablemessage4Inputs */



/**
* | output |
* | --- |
* | "RuStore can't accept payments right now. Please try again a bit later." |
*
* @param {Subscriptionalertpurchaseunavailablemessage4Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const subscriptionalertpurchaseunavailablemessage4 = /** @type {((inputs?: Subscriptionalertpurchaseunavailablemessage4Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscriptionalertpurchaseunavailablemessage4Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("RuStore can't accept payments right now. Please try again a bit later.")
	if (locale === "es") return /** @type {LocalizedString} */ ("RuStore no puede aceptar pagos ahora. Inténtalo de nuevo un poco más tarde.")
	return /** @type {LocalizedString} */ ("RuStore сейчас не принимает оплату. Попробуйте ещё раз чуть позже.")
});
export { subscriptionalertpurchaseunavailablemessage4 as "subscriptionAlertPurchaseUnavailableMessage" }